import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import useAuth from '../../../../features/hooks/useAuth';
import UnivConReqComp from '../UnivConReqComp';


const Container = styled.div`
  margin-top: 20px;
`;

const ConsumSentTable = ({ subTabValue, handleEditclick }) => {
 const Auth = useAuth();
  const [limit, setLimit] = useState(5);
  const [lastId, setLastId] = useState(null);
  const [filterProps, setFilterProps] = useState({});  

  useEffect(() => {
    if (!Auth?.id) return;
  
    let updatedFilterProps = {};
    let sent_to_tag_filter = [];
  
    switch (subTabValue) {
      case 0:
        // User Sentbox
        sent_to_tag_filter = [
          "cosumureq_created"
        ];
        break;
      case 1:
        // BO Sentbox
        sent_to_tag_filter = [
         "botostore_consreq_created",
         "boreq_bts_rtrned_uhlvl",
         "boreq_bts_resubmit_uh",
         "bo_returnto_user_cir"
        ];
        break;
      case 2:
        // Unit Head Sentbox
        sent_to_tag_filter = [
          "boreq_bts_rtrned_uhlvl",
          "uhreq_bts_forward_store",
          "boreq_bts_resubmit_uh"
        ];
        break;
      case 3:
        //Asset Manager-I Inbox
        sent_to_tag_filter = [
          "storel1_bts_partialissue_l2",
          "storel1_bts_fullissue_l2"
        ];
        break;
      case 4:
        //Asset Manager-II Inbox
        sent_to_tag_filter = [
          "storel2_bts_return_l1"
 
        ];
        break;
      case 6:
        // All Requests - no specific tags, show all requests for the store
        sent_to_tag_filter = [];
        break;
      default:
    }
  
    // Filter for outbox - show items where current user sent items with specific tags
    if (subTabValue === 6) {
      // All Requests - show all requests for the current user's store only
      updatedFilterProps = {
        perm_req_store: Auth.store ? [Auth.store] : []
      };
    } else {
      // Regular filtering for other sub tabs
      updatedFilterProps = {
        req_data_sent_to_tags: { id:Auth.id, tags:sent_to_tag_filter?.length? sent_to_tag_filter : ["Not Applicable"] },
        perm_flow_users: [Auth.id]
      };
    }

    // Add status filter like asset requests
    if (subTabValue !== 5) {
      updatedFilterProps.perm_curr_status = ["Pending"]
    } else {
      updatedFilterProps.perm_curr_status = ["Rejected", "Closed"]
    }
  
    setFilterProps(prevProps => {
      return JSON.stringify(prevProps) !== JSON.stringify(updatedFilterProps) ? updatedFilterProps : prevProps;
    });
    
  }, [Auth?.id, subTabValue]);

  const columnFilter = [
    "UniqueReqId", "Req_Type", "Req_Creator", "Store", "Curr_Status", "Created_At",
    "Currently_With", "Status", "Action"
  ];
console.log(filterProps)
  return (
    <>    
      <UnivConReqComp
        filterProps={filterProps}  
        columnFilter={columnFilter}
        handleEditclick={handleEditclick}
        limit={limit} 
        setLimit={setLimit} 
        lastId={lastId} 
        setLastId={setLastId}
        viewType="sentbox"
      />   
    </>
  );
}

export default ConsumSentTable; 